import React from 'react';

import { instance, comma } from '../../common';
import Check_o from '../../img/gg_check-o.png';
import Check_e from '../../img/ic_sharp-error-outline.png';

const btnWdith = {
  width: '150px',
  backgroundColor: '#2F79D9',
  color: 'white'
};
const imgWidth = {
  width: '20px',
  margin: '1rem 0',
  marginRight: '1rem'
};


export function CustomAlert({
  history,
  pro,
  r_id,
  co_discount,
  inputs,
  promotionText,
}) {

  const goPage = () => {
    let obj = {
      contract_num: inputs,
    };
    let valueObj = {
      obj: obj,
      whereField: 'r_id',
      whereValue: r_id,
    };
    const fetchData = async () => {
      instance.post('/reserve/update', valueObj).then(function (res) {});
    };

    fetchData();
		window.location.reload();
  };
  return (
    <>
      <img src={Check_o} style={imgWidth} />
      <span className="font-weight-bold d-inline-block" style={{ fontSize:"16px" }}>
        정상적으로 인증되었습니다. 감사합니다.
      </span>

      {pro == 1 && (
        <>
          <h4 className="font-weight-bold mt-5">프로모션 : 프로모션 상품</h4>
          <h4 className="font-weight-bold mt-3 mb-4">
            할인금액 : {comma(co_discount)} 원
          </h4>
        </>
      )}

      <h5 className="font-weight-bold mb-5">
        ※ 현대캐피탈 할부 취소시, 예약이 취소 될 수 있습니다.
      </h5>
      <span
        className="btn pt-3 pb-3 w-100"
        style={btnWdith}
        onClick={goPage}
      >
        완료하기
      </span>
    </>
  );
}

export function CustomAlert2({ onConfirm, popup, setPopup, promotionText }) {

  const onClick = () => {
		onConfirm(false);
    setPopup({
      ...popup,
      no: false,
    });
  };

  return (
    <>
      <img src={Check_e} style={imgWidth} />
      {promotionText === '계약번호' ? (
        <>
          <span className="font-weight-bold my-3 d-inline-block"  style={{ fontSize:"16px" }}>현대캐피탈 계약번호가 아닙니다.</span>
        </>
      ) : (
        <span className="font-weight-bold my-3 d-inline-block"  style={{ fontSize:"16px" }}>{promotionText}가 아닙니다.</span>
      )}
      <h4 className="font-weight-bold mb-5">다시 확인해주세요.</h4>
      {promotionText === '계약번호' && (
        <>
          <h5 className="font-weight-bold">
            ※ 현대캐피탈 할부 미확정시, 인증이 되지 않습니다.
          </h5>
          <h5 className="font-weight-bold mb-5">
            할부 확정 후 +1 영업일에 재인증 해주세요.
          </h5>
        </>
      )}

      <h4 className="font-weight-bold mb-5">고객문의 : 1544-2160</h4>
      <span
        className="btn pt-3 pb-3 w-100"
        style={btnWdith}
        onClick={onClick}
      >
        확인
      </span>
    </>
  );
}

export function CustomAlert3({ onConfirm, popup, setPopup, promotionText }) {

  const onClick = () => {
		onConfirm(false);
    setPopup({
      ...popup,
      ex: false,
    });
  };

  return (
    <>
      <img src={Check_e} style={imgWidth} />
      <span className="font-weight-bold mt-3 d-inline-block" style={{ fontSize:"16px" }}>이미 인증된 {promotionText}입니다.</span>

      <h4 className="font-weight-bold mb-5">
        다른 {promotionText}를 입력해주세요.
      </h4>
      {promotionText === '계약번호' && (
        <>
          <h5 className="font-weight-bold">
            ※ 현대캐피탈 할부 미확정시, 인증이 되지 않습니다.
          </h5>
          <h5 className="font-weight-bold mb-5">
            할부 확정 후 +1 영업일에 재인증 해주세요.
          </h5>
        </>
      )}

      <h4 className="font-weight-bold mb-5">고객문의 : 1544-2160</h4>
      <span
        className="btn pt-3 pb-3 w-100"
        style={btnWdith}
        onClick={onClick}
      >
        확인
      </span>
    </>
  );
}

//일치하지 않는 alert창
export function CustomAlert_x({ onConfirm, popup, setPopup, promotionText }) {

  const onClick = () => {
		onConfirm(false);
    setPopup({
      ...popup,
      format: false,
    });
  };

  return (
    <>
      <img src={Check_e} style={imgWidth} />
      <span className="font-weight-bold d-inline-block" style={{ fontSize:"16px" }}>
        형식에 맞는 {promotionText}를 입력해주세요.
      </span>

      <h5 className="font-weight-bold mt-3">
        ※ 영문, 숫자로 이루어진 13자리를 입력해주세요.
      </h5>

      <h4 className="font-weight-bold mt-3 mb-5">고객문의 : 1544-2160</h4>
      <span
        className="btn pt-3 pb-3 w-100"
        style={btnWdith}
        onClick={onClick}
      >
        확인
      </span>
    </>
  );
}
